// tslint:disable
/**
 * GetInfo
 * Get info api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Company } from './company';
import { ContactPerson } from './contact-person';
import { Employee } from './employee';
import { User } from './user';

/**
 * 
 * @export
 * @interface ContractorNew
 */
export interface ContractorNew {
    /**
     * 
     * @type {string}
     * @memberof ContractorNew
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractorNew
     */
    type?: string;
    /**
     * 
     * @type {User}
     * @memberof ContractorNew
     */
    user?: User;
    /**
     * 
     * @type {Company}
     * @memberof ContractorNew
     */
    company: Company;
    /**
     * 
     * @type {Employee}
     * @memberof ContractorNew
     */
    responsible?: Employee;
    /**
     * 
     * @type {string}
     * @memberof ContractorNew
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractorNew
     */
    email?: string;
    /**
     * 
     * @type {Date}
     * @memberof ContractorNew
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ContractorNew
     */
    updatedAt?: Date;
    /**
     * 
     * @type {ContactPerson}
     * @memberof ContractorNew
     */
    contactPerson?: ContactPerson;
    /**
     * 
     * @type {string}
     * @memberof ContractorNew
     */
    comment?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ContractorNew
     */
    studentIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ContractorNew
     */
    fullName: string;
    /**
     * 
     * @type {string}
     * @memberof ContractorNew
     */
    objectType: ContractorNewObjectTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum ContractorNewObjectTypeEnum {
    PhysicalContractorNew = 'PhysicalContractorNew',
    JuridicalContractorNew = 'JuridicalContractorNew'
}



